module.exports = __webpack_public_path__ + "static/media/products_services5.59f69a73.jpg";